import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { PagingSearchFieldArgument } from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';
import { PagingArgument } from 'src/lib/utilities/api/patterns/pagination/paging.argument';
import {
	TrackerUserPerformance,
	TrackerUserPerformance_ClassTransform_Type,
} from '../students/performance/student-performance-history-detailed.model';
import {
	WorkQueueTrackerResponseModel,
	WorkQueueTrackerResponseModel_ClassTransform_Type,
} from '../work-queue/work-queue-entity.model';

export class RegistrarTrackerModel {
	get profile_first_name() {
		return this.first_name;
	}
	get profile_preferred_name() {
		return this.first_name;
	}
	get profile_last_name() {
		return this.last_name;
	}

	first_name: string;
	last_name: string;
	uid: number;
	institute_id: number;
	institute_title: string;
	institute_type: string;
	institute_state: string;
	enrollment_status: number;
	program_status: string;
	@Transform(dateTransformer)
	college_deadline: Date;
	@Transform(dateTransformer)
	graduation_date: Date;
	@Type(TrackerUserPerformance_ClassTransform_Type)
	performance_data: TrackerUserPerformance;
	@Transform(dateTransformer)
	pause_start_date: Date;
	@Transform(dateTransformer)
	pause_end_date: Date;
	pause_status: 'pending' | 'approved';
	pause_exit_code: number;
	pause_exit_code_title: string;
	reason: string;
	@Transform(dateTransformer)
	scheduled_withdrawal_date: Date;
	withdrawal_exit_code: number;
	withdrawal_exit_title: string;
	@Transform(dateTransformer)
	unactivated_date: Date;
	unactivated_reason: string;

	@Transform(dateTransformer)
	approved_on: Date;
	approved_by: string;
	approved_by_name: number;

	@Transform(dateTransformer)
	authorized_on: Date;
	authorized_by: string;
	authorized_by_name: number;

	request_id: number;
	request_type: string;
	@Transform(dateTransformer)
	requested_on: Date;
	requested_by: string;
	requested_by_name: string;

	@Type(WorkQueueTrackerResponseModel_ClassTransform_Type)
	queues: WorkQueueTrackerResponseModel[];
}

export function RegistrarTrackerModel_ClassTransform_Type() {
	return RegistrarTrackerModel;
}

export class RegistrarTrackerResponseModel {
	success: boolean;
	count: number;
	@Type(RegistrarTrackerModel_ClassTransform_Type)
	results: RegistrarTrackerModel[];
}

export interface RegistrarTrackerPagingArgument extends PagingArgument<RegistrarTrackerSearchArgument> {
	shown_categories:
		| 'withdrawn'
		| 'withdrawn_requested'
		| 'paused'
		| 'pause_requested'
		| []; // used for toggles
}

export interface RegistrarTrackerSearchArgument {
	first_name: PagingSearchFieldArgument;
	last_name: PagingSearchFieldArgument;
	uid: PagingSearchFieldArgument;
	institute_title: PagingSearchFieldArgument;
	institute_type: PagingSearchFieldArgument;
	institute_state: PagingSearchFieldArgument;
	enrollment_status: PagingSearchFieldArgument;
	pause_start_date: PagingSearchFieldArgument;
	pause_end_date: PagingSearchFieldArgument;
	withdrawal_date: PagingSearchFieldArgument;
	unactivated_date: PagingSearchFieldArgument;

	requested_on: PagingSearchFieldArgument;
	requested_by: PagingSearchFieldArgument;
	requested_by_name: PagingSearchFieldArgument;

	work_queue: PagingSearchFieldArgument;
	work_queue_count: PagingSearchFieldArgument;
	approved_on: PagingSearchFieldArgument;
	approved_by: PagingSearchFieldArgument;
	authorized_on: PagingSearchFieldArgument;
	authorized_by: PagingSearchFieldArgument;
	authorized_by_name: PagingSearchFieldArgument;
}

//id, first, last, program, program type, program state, requested on, requested by

export interface PauseRequestTrackerSearchArgument extends RegistrarTrackerSearchArgument {
	pause_reason: PagingSearchFieldArgument;
	pause_start_date: PagingSearchFieldArgument;
	pause_end_date: PagingSearchFieldArgument;
	pause_exit_code_title: PagingSearchFieldArgument;
}

export interface WithdrawRequestTrackerSearchArgument extends RegistrarTrackerSearchArgument {
	withdrawal_explanation: PagingSearchFieldArgument;
	withdrawal_scheduled_date: PagingSearchFieldArgument;
}
